// This component composes the inputs with the specific params for this model

import React from "react";
import { GuidanceScaleParam } from "../generator_subcomponents/condition_scale";
import { ImageSizeParam } from "../generator_subcomponents/image_size";
import { NumImagesParam } from "../generator_subcomponents/num_images";
import { ParamsGrid } from "../generator_subcomponents/params_grid";
import { SeedParam } from "../generator_subcomponents/seed";
import { StepsParam } from "../generator_subcomponents/steps";
import { useGenie } from "../use_genie";
import { VerdantParams } from "./model_generation_component_types";

export const Verdant: React.FC = () => {
  // Individual model components like this one should grab params and pass down
  // primitive types to the subcomponents. Subcomponents are responsible for
  // dispatching actions to the store.
  // Model specifics can be found at
  // https://github.com/dryadsystems/sprkpnt/blob/main/api/params.md#diffuse

  const params = useGenie();
  const verdantParams = params.allModelsParams.verdant as VerdantParams;

  return (
    <ParamsGrid>
      <NumImagesParam num={verdantParams.num_images} />
      {params.viewProps.mode !== "img2img" && (
        <ImageSizeParam
          width={verdantParams.width}
          height={verdantParams.height}
        />
      )}
      <SeedParam seed={verdantParams.seed} />
      <GuidanceScaleParam scale={verdantParams.scale} />
      <StepsParam steps={verdantParams.ddim_steps} />
    </ParamsGrid>
  );
};
